module.exports = __webpack_public_path__ + "img/success.16b381b9.png";